// src/components/admin/shared/StatusBadge.js
import React from 'react';
import { CheckCircle, AlertTriangle, Clock, XCircle } from 'lucide-react';

const StatusBadge = ({ status }) => {
  let badgeClasses = '';
  let icon = null;
  let statusText = status;
  
  switch(status) {
    case 'published':
      badgeClasses = 'bg-green-100 text-green-800';
      icon = <CheckCircle className="h-3 w-3 mr-1" />;
      break;
    case 'draft':
      badgeClasses = 'bg-amber-100 text-amber-800';
      icon = <AlertTriangle className="h-3 w-3 mr-1" />;
      break;
    case 'scheduled':
      badgeClasses = 'bg-blue-100 text-blue-800';
      icon = <Clock className="h-3 w-3 mr-1" />;
      break;
    case 'archived':
      badgeClasses = 'bg-gray-100 text-gray-800';
      icon = <XCircle className="h-3 w-3 mr-1" />;
      break;
    default:
      badgeClasses = 'bg-gray-100 text-gray-800';
      statusText = statusText || 'Unknown';
  }
  
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${badgeClasses}`}>
      {icon}
      {statusText}
    </span>
  );
};

export default StatusBadge;